import React, { useEffect } from "react";
import { connect } from "react-redux";

import Col from "antd/es/col";
import Row from "antd/es/row";
import Tabs from "antd/es/tabs";
import { useIntl } from "react-intl";

import { EntityType, EntityTypeSupportingDataMerging } from "@mapmycustomers/shared/types/entity";

import { RootState } from "@app/store/rootReducer";
import { getEntityTypeDisplayName } from "@app/util/ui";

import { dataMergingAnalytics } from "../../settingsAnaytics";
import SettingPage from "../common/SettingPage";

import EntityTable from "./component/EntityTable";
import LastCalculated from "./component/LastCalculated";
import ToolBar from "./component/ToolBar";
import styles from "./MergeDuplicates.module.scss";
import { getEntityType } from "./store";
import { fetchDuplicates, selectEntityType } from "./store/actions";

interface Props {
  entityType: EntityTypeSupportingDataMerging;
  onFetchDuplicates: typeof fetchDuplicates.request;
  selectEntityType: typeof selectEntityType;
}

const MergeDuplicates: React.FC<Props> = ({ entityType, onFetchDuplicates, selectEntityType }) => {
  const intl = useIntl();

  useEffect(() => {
    onFetchDuplicates({});
  }, [onFetchDuplicates]);

  return (
    <SettingPage
      actions={<LastCalculated />}
      title={
        <div>
          {intl.formatMessage({
            id: "settings.mergeDuplicates.title",
            defaultMessage: "Merge Duplicates",
            description: "Title of settings Merge Duplicates page",
          })}
          <div className={styles.pageDescription}>
            {intl.formatMessage({
              id: "settings.mergeDuplicates.description",
              defaultMessage:
                "Review suggested duplicates and merge them together to keep your data in shape. Please note, potential duplicate records are calculated on a weekly basis.",
              description: "Description of settings Merge Duplicates page",
            })}
          </div>
        </div>
      }
    >
      <Row align="middle" justify="space-between">
        <Col span={12}>
          <Tabs
            activeKey={entityType}
            onChange={(key) => {
              selectEntityType(key as EntityTypeSupportingDataMerging);
              dataMergingAnalytics?.clicked([
                getEntityTypeDisplayName(intl, key as EntityType, {
                  lowercase: false,
                  plural: true,
                }),
              ]);
            }}
          >
            <Tabs.TabPane
              key={EntityType.COMPANY}
              tab={getEntityTypeDisplayName(intl, EntityType.COMPANY, {
                lowercase: false,
                plural: true,
              })}
            />
            <Tabs.TabPane
              key={EntityType.PERSON}
              tab={getEntityTypeDisplayName(intl, EntityType.PERSON, {
                lowercase: false,
                plural: true,
              })}
            />
          </Tabs>
        </Col>
        <Col span={12}>
          <Row align="middle" justify="end">
            <Col>
              <ToolBar />
            </Col>
          </Row>
        </Col>
      </Row>
      <EntityTable />
    </SettingPage>
  );
};

const mapStateToProps = (state: RootState) => ({
  entityType: getEntityType(state),
});

const mapDispatchToProps = {
  onFetchDuplicates: fetchDuplicates.request,
  selectEntityType,
};

export default connect(mapStateToProps, mapDispatchToProps)(MergeDuplicates);
